import React from "react";
import { createPortal } from "react-dom";
import { Box } from "@dxp-feed/ui/Box";
import { Button } from "@dxp-feed/ui/Button";
import { SlidePanel } from "@dxp-feed/ui/SlidePanel";
import Link from "@/components/Link";
import { Text } from "@dxp-feed/ui/Text";
import OfferCard from "@/components/OfferCard";

interface GroupOffersProps {
  promotionsItemsData: any;
  isPanelOpen: boolean;
  setIsPanelOpen: (isOpen: boolean) => void;
  productPromotions: any;
}

export default function GroupOffers({
  promotionsItemsData,
  isPanelOpen,
  setIsPanelOpen,
  productPromotions,
}: GroupOffersProps) {
  const panelContent = (
    <Box as="div" className="[&>div.bg-brandBlack]:bg-grey600 [&>div.bg-brandBlack]:opacity-50 fixed inset-0 z-[9999]">
      <SlidePanel
        side="right"
        isOpen={isPanelOpen}
        className="w-full max-w-[756px]"
      >
        <Box as="div" className="p-0">
          <Box
            as="div"
            className="relative top-0 left-0 right-0 bg-white z-[2]"
          >
            <Box
              as="div"
              className="flex items-start justify-between p-6 border-b-2 border-b border-grey350"
            >
              <Box as="div">
                <Box as="div" className="text-base text-black font-bold max-w-[250px] sm:max-w-full">
                  Great news! This product is part of a special group offer.
                </Box>
              </Box>
              <Button
                className="text-gray-500 font-bold text-lg"
                onClick={() => setIsPanelOpen(false)}
                aria-label="Close modal"
                variant="icon"
                size="none"
              >
                <Text
                  as="span"
                  className="icon-close text-brandBlack text-[14px]"
                ></Text>
              </Button>
            </Box>
          </Box>
          <Box as="div" className="p-6 pt-4">
            <Box as="div" className="text-body text-black mb-3">
              Buy eligible products and earn{" "}
              <strong>
                {promotionsItemsData?.[0]?.memberPrice} Scene+{" "}
                {promotionsItemsData?.[0]?.rewardDescription}!
              </strong>
            </Box>
            <Box
              as="div"
              className="grid grid-cols-1 2xs:grid-cols-2 md:grid-cols-3 gap-5 2xs:gap-[8px] xs:gap-[16px] lg:gap-[24px] overflow-y-auto max-h-[calc(100vh-180px)] md:max-h-[calc(100vh-150px)] pb-[100px] px-[2px] pt-1"
            >
              {productPromotions.length > 0 ? (
                productPromotions.map((item: any) => (
                  <OfferCard key={item.objectID} item={item} isOpen={true} />
                ))
              ) : (
                <Box
                  as="div"
                  className="w-full text-center flex items-center justify-center absolute left-0 right-0 top-0 bottom-0 mx-auto font-bold"
                >
                  No Data Found
                </Box>
              )}
            </Box>
          </Box>

          <Box
            as="div"
            className="flex bg-white shadow-[0_-3px_7px_0_rgba(0,0,0,0.28)] pt-3 px-2 2xs:px-6 !py-[12px] absolute bottom-0 left-0 right-0 h-[68.78px] z-[99]"
          >
            <Box
              as="div"
              className="w-full flex items-center justify-end gap-5"
            >
              <Link
                href="#"
                className="text-sm 4xs:text-body underline hover:no-underline font-bold text-brandSecondary"
                onClick={() => setIsPanelOpen(false)}
              >
                Continue Shopping
              </Link>
              <Button
                variant="primary"
                className="font-normal !text-sm 4xs:!text-body !4xs:px-4 !px-6"
              >
                <Link href="/manage-list">View Shopping List</Link>
              </Button>
            </Box>
          </Box>
        </Box>
      </SlidePanel>
    </Box>
  );
  if (!isPanelOpen || typeof window === 'undefined') {
    return null;
  }
  return createPortal(panelContent, document.body);
}